// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__lcfbq","leftArrow":"Slider_leftArrow__bEJAf","rightArrow":"Slider_rightArrow__Skojy","sliderContent":"Slider_sliderContent__ossgy"};